<template>
	<div v-if="$props.info" class="arm-info">
		<div class="arm-info__list">
			<div v-for="item of $props.info" :key="item.name" class="arm-info__list-item">
				<div class="arm-info__list-item-name">{{ item.name }}</div>
				<div class="arm-info__list-item-value">{{ item.value }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ArmInfo',
		props: {
			info: {
				type: Array,
				default: () => ([]),
				validator: array => array.every(item => typeof item === "object" && item.name && item.value)
			}
		}
	}
</script>
